import { createContext, useContext, useState, useCallback, ReactNode } from 'react'
import { Loading } from '../componentesCompartilhados/ui/Loading'

interface LoadingContextType {
  isLoading: boolean
  message?: string
  startLoading: (message?: string) => void
  stopLoading: () => void
}

const LoadingContext = createContext<LoadingContextType | undefined>(undefined)

export function LoadingProvider({ children }: { children: ReactNode }) {
  const [loading, setLoading] = useState<{ isLoading: boolean; message?: string }>({ 
    isLoading: false 
  })

  const startLoading = useCallback((message?: string) => {
    setLoading({ isLoading: true, message })
  }, [])

  const stopLoading = useCallback(() => {
    setLoading({ isLoading: false })
  }, [])

  return (
    <LoadingContext.Provider value={{
      isLoading: loading.isLoading,
      message: loading.message,
      startLoading,
      stopLoading
    }}>
      {children}
      {loading.isLoading && (
        <Loading fullScreen text={loading.message} />
      )}
    </LoadingContext.Provider>
  )
}

export function useGlobalLoading() {
  const context = useContext(LoadingContext)
  if (context === undefined) {
    throw new Error('useGlobalLoading must be used within a LoadingProvider')
  }
  return context
}



